export function userClassification() {
  let code = localStorage.getItem('thp_user_code')

  if (code) {
    let userGroup = ''
    switch (code) {
      case 'THP-CallCenter':
      case 'THP-DeptAdmin':
      case 'THP-SystemAdmin':
        userGroup = '0'
        break
      case 'THP-USER':
      case 'THP-Payee':
      case 'THP-PM':
      case 'THP-ProjectStaff':
      case 'THP-Node':
        userGroup = '1'
        break
      case 'THP-Coordinator':
        userGroup = '2'
        break
      case 'THP-Expert':
        userGroup = '3'
        break
      case 'THP-Director':
        userGroup = '5'
        break
      case 'THP-Manager':
        userGroup = '7'
        break
      case 'THP-AsstManager':
        userGroup = '12'
        break
      case 'THP-AsstDirector':
        userGroup = '11'
        break
      case 'THP-ContractCenter':
        userGroup = '8'
        break
      case 'THP-Legal':
        userGroup = '10'
        break
      default:
        break
    }
    return userGroup
  } else {
    return null
  }
}

export function validateLogined() {
  const token = localStorage.getItem('access_token')
  const uid = localStorage.getItem('thp_user_uid')
  const code = localStorage.getItem('thp_user_code')

  if (token && uid && code) {
    return true
  } else {
    return false
  }
}
